import React from 'react'
import classnames from "classnames";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { addCrypto } from "../../actions/cryptoActions";
import { withRouter } from "react-router-dom";
import { toast } from 'react-toastify';
import $ from 'jquery';

import 'react-toastify/dist/ReactToastify.css';

class CryptoAddModal extends React.Component {

    constructor() {
        super();
        this.state = {
            name: "",
            short_name:"",
            // order_sequence:"",
            errors: {},
            // coinImage: '',
            // is_deposit:0,
            // is_withdrawal:0,
            // is_trade:0,
            // is_show:0,
        };
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.errors) {
            this.setState({
                errors: nextProps.errors
            });
        }
       
    }
    handleChange = (event) => {
        let { name, value } = event.target;
        console.log("valuefdvfdv",event.target)
        this.setState({ [name]: value, emptyField: false, errMsg: "" });
      };

    // onChange = e => {

    //     if (e.target.name === 'currencyImage') {
    //         var currencyImage = e.target.files[0];
            
    //         var fileSize = e.target.files[0].size;
    //         if (fileSize > 1000000) {
    //             this.setState({ invalidImage: "Maximum 1 MB Image allowed.", userUploadImage: false });
    //             return false;
    //         }
    //         console.log(this.state.invalidImage);
    //         if (!currencyImage.name.match(/\.(jpg|jpeg|png|gif)$/)) {
    //             this.setState({ invalidImage: "Please select valid image jpeg,png,gif.", userUploadImage: false });
    //             return false;
    //         }
        
    //         this.setState({
    //             coinImage: currencyImage,
    //         });
    //     }

    //     this.setState({ [e.target.id]: e.target.value });
    // };

    onCryptoAdd = e => {
        e.preventDefault();
        console.log("YTest",this.state.chain)
        
        const config = {
            headers: {
                'content-type': 'multipart/form-data'
            }
        }
        const data={
            coin_name:this.state.name,
            short_name:this.state.short_name
        }
        
        // const formData = new FormData();
        // formData.append('currencyImage',this.state.coinImage);
        // formData.append('name',this.state.name);
        // formData.append('short_name',this.state.short_name);
        // formData.append('chain',this.state.chain);
        // formData.append('url',this.state.url);
        // formData.append('order_sequence',this.state.order_sequence);
        // formData.append('is_deposit',this.state.is_deposit);
        // formData.append('is_withdrawal',this.state.is_withdrawal);
        // formData.append('is_trade',this.state.is_trade);
        // formData.append('is_show',this.state.is_show);
        this.props.addCrypto(data,config);
    };

    render() {
        const { errors } = this.state;
        return (
            <div>
                <div className="modal fade" id="add-user-modal" data-reset="true">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title">Add Crypto Currency</h4>
                                <button type="button" className="close" data-dismiss="modal">&times;</button>
                            </div>
                            <div className="modal-body">
                                <form noValidate onSubmit={this.onCryptoAdd} id="add-user">
                                    <div className="row mt-2">
                                        <div className="col-md-3">
                                            <label htmlFor="name">Currency Name</label>
                                        </div>
                                        <div className="col-md-9">
                                            <input
                                                onChange={this.onChange}
                                                value={this.state.name}
                                                id="name"
                                                name="name"
                                                type="text"
                                                error={errors.name}
                                                className={classnames("form-control", {
                                                    invalid: errors.name
                                                })}/>
                                            <span className="text-danger">{errors.name}</span>
                                        </div>
                                    </div>

                                    <div className="row mt-2">
                                        <div className="col-md-3">
                                            <label htmlFor="name">Currency Short Name</label>
                                        </div>
                                        <div className="col-md-9">
                                            <input
                                                onChange={this.onChange}
                                                value={this.state.short_name}
                                                id="short_name"
                                                name="short_name"
                                                type="text"
                                                error={errors.short_name}
                                                className={classnames("form-control", {
                                                    invalid: errors.short_name
                                                })}/>
                                            <span className="text-danger">{errors.short_name}</span>
                                        </div>
                                    </div>

                                    <div className="row mt-2">
                                        <div className="col-md-3">
                                            <label htmlFor="chain">Currency Chain Type</label>
                                        </div>
                                        <div className="col-md-9">
                                            <select value={this.state.chain} name="chain" onChange={this.handleChange} className="form-control">
                                                <option value="">Select</option>
                                                <option value="ETH">ETH</option>
                                                <option value="BSC">BSC</option>
                                                <option value="TRON">TRON</option>
                                            </select>
                                            {/* <input
                                                onChange={this.onChange}
                                                value={this.state.chain}
                                                id="chain"
                                                name="chain"
                                                type="text"
                                                error={errors.chain}
                                                className={classnames("form-control", {
                                                    invalid: errors.chain
                                                })}/> */}
                                            <span className="text-danger">{errors.chain}</span>
                                        </div>
                                    </div>

                                    {/* <div className="row mt-2">
                                        <div className="col-md-3">
                                            <label htmlFor="url">Currency Chain Url</label>
                                        </div>
                                        <div className="col-md-9">
                                            <input
                                                onChange={this.onChange}
                                                value={this.state.url}
                                                id="url"
                                                name="url"
                                                type="text"
                                                error={errors.url}
                                                className={classnames("form-control", {
                                                    invalid: errors.url
                                                })}/>
                                            <span className="text-danger">{errors.url}</span>
                                        </div>
                                    </div> */}

                                    <div className="row mt-2">
                                        <div className="col-md-3">
                                            <label htmlFor="name">Currency Image</label>
                                        </div>
                                        <div className="col-md-9">
                                            <input
                                                onChange={this.onChange}
                                                value={this.state.currencyImage}
                                                id="currencyImage"
                                                name="currencyImage"
                                                type="file"
                                                error={errors.currencyImage}
                                                className={classnames("form-control", {
                                                    invalid: errors.currencyImage
                                                })}/>
                                                
                                            <span className="text-danger">{errors.currencyImage}</span>
                                        </div>
                                    </div>

                                    <div className="row mt-2">
                                        <div className="col-md-3">
                                            <label htmlFor="is_deposit">Deposit</label>
                                        </div>
                                        <div className="col-md-9">
                                            <div className="form-check-inline">
                                                <label className="form-check-label">

                                                    <input
                                                        checked={this.state.is_deposit == 1}
                                                        onChange={this.onChange}
                                                        value="1"
                                                        name="is_deposit"
                                                        type="radio" className="form-check-input"
                                                        id="is_deposit"
                                                    />Enabled
                                                </label>
                                            </div>
                                            <div className="form-check-inline">
                                                <label className="form-check-label">
                                                    <input
                                                        checked={this.state.is_deposit == 0}
                                                        onChange={this.onChange}
                                                        value="0"
                                                        name="is_deposit"
                                                        id="is_deposit"
                                                        type="radio" className="form-check-input"
                                                    />
                                                    Suspended
                                                </label>
                                            </div>

                                        </div>
                                    </div>

                                    <div className="row mt-2">
                                        <div className="col-md-3">
                                            <label htmlFor="is_withdrawal">Withdrawal</label>
                                        </div>
                                        <div className="col-md-9">
                                            <div className="form-check-inline">
                                                <label className="form-check-label">

                                                    <input
                                                        checked={this.state.is_withdrawal == 1}
                                                        onChange={this.onChange}
                                                        value="1"
                                                        name="is_withdrawal"
                                                        type="radio" className="form-check-input"
                                                        id="is_withdrawal"
                                                    />Enabled
                                                </label>
                                            </div>
                                            <div className="form-check-inline">
                                                <label className="form-check-label">
                                                    <input
                                                        checked={this.state.is_withdrawal == 0}
                                                        onChange={this.onChange}
                                                        value="0"
                                                        name="is_withdrawal"
                                                        id="is_withdrawal"
                                                        type="radio" className="form-check-input"
                                                    />
                                                    Suspended
                                                </label>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row mt-2">
                                        <div className="col-md-3">
                                            <label htmlFor="is_trade">Trade</label>
                                        </div>
                                        <div className="col-md-9">
                                            <div className="form-check-inline">
                                                <label className="form-check-label">

                                                    <input
                                                        checked={this.state.is_trade == 1}
                                                        onChange={this.onChange}
                                                        value="1"
                                                        name="is_trade"
                                                        type="radio" className="form-check-input"
                                                        id="is_trade"
                                                    />Enabled
                                                </label>
                                            </div>
                                            <div className="form-check-inline">
                                                <label className="form-check-label">
                                                    <input
                                                        checked={this.state.is_trade == 0}
                                                        onChange={this.onChange}
                                                        value="0"
                                                        name="is_trade"
                                                        id="is_trade"
                                                        type="radio" className="form-check-input"
                                                    />
                                                    Suspended
                                                </label>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row mt-2">
                                        <div className="col-md-3">
                                            <label htmlFor="is_show">Is Show</label>
                                        </div>
                                        <div className="col-md-9">
                                            <div className="form-check-inline">
                                                <label className="form-check-label">

                                                    <input
                                                        checked={this.state.is_show == 1}
                                                        onChange={this.onChange}
                                                        value="1"
                                                        name="is_show"
                                                        type="radio" className="form-check-input"
                                                        id="is_show"
                                                    />Enabled
                                                </label>
                                            </div>
                                            <div className="form-check-inline">
                                                <label className="form-check-label">
                                                    <input
                                                        checked={this.state.is_show == 0}
                                                        onChange={this.onChange}
                                                        value="0"
                                                        name="is_show"
                                                        id="is_show"
                                                        type="radio" className="form-check-input"
                                                    />
                                                    Suspended
                                                </label>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row mt-2">
                                        <div className="col-md-3">
                                            <label htmlFor="name">Order Sequence</label>
                                        </div>
                                        <div className="col-md-9">
                                            <input
                                                onChange={this.onChange}
                                                value={this.state.order_sequence}
                                                id="order_sequence"
                                                name="order_sequence"
                                                type="number"
                                                error={errors.order_sequence}
                                                className={classnames("form-control", {
                                                    invalid: errors.order_sequence
                                                })}/>
                                            <span className="text-danger">{errors.order_sequence}</span>
                                        </div>
                                    </div>
                                
                                </form>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-dismiss="modal">Close</button>
                                <button
                                    form="add-user"
                                    type="submit"
                                    className="btn btn-primary">
                                    Save
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

CryptoAddModal.propTypes = {
    addCrypto: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired,
    errors: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    auth: state.auth,
    errors: state.errors
});

export default connect(
    mapStateToProps,
    { addCrypto }
)(withRouter(CryptoAddModal));